import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { LiveMarketCapHeading } from "../../../../utils/Constant";
import ReactApexChart from "react-apexcharts";
import { liveMarketCap } from "../../../../Data/Dashboard/DashboardCharts/DashboardCharts";

const LiveMarketCap = () => {
  return (
    <Col xl="6" className="proorder-xl-12 proorder-lg-12">
      <Card className="market-chart">
        <CardHeaderCommon title={LiveMarketCapHeading} mainTitle="Yearly" firstItem="Today" secondItem="Tomorrow" thirdItem="Yesterday" />
        <CardBody className="pt-0">
          <ReactApexChart options={liveMarketCap} series={liveMarketCap.series} type="boxPlot" height={360} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default LiveMarketCap;
